import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.review.task.item');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-review-task-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.review.task.item/view.scss */
:host {
  display: block;
  min-width: 0;
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #202124;
}

.assigned-review-detail {
  min-height: 100%;
  background: #f6f6f7;
}

.review-detail-header {
  z-index: 20;
  border-bottom: 1px solid #dedee1;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(12px);
}

.review-detail-heading {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  gap: 14px;
}

.review-back-link {
  display: inline-flex;
  width: 36px;
  height: 36px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #d7d7db;
  border-radius: 6px;
  color: #5f6067;
  background: #fff;
  transition: all 160ms ease;
}

.review-back-link:hover {
  border-color: #a8a8ad;
  color: #202124;
  background: #f0f0f1;
}

.review-detail-heading__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 7px;
  margin-bottom: 7px;
  color: #73747b;
  font-size: 12px;
  font-weight: 700;
}

.review-kind-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 4px 9px;
  color: #fff;
  background: #303136;
}

.review-detail-heading h1 {
  margin: 0;
}

.review-detail-heading p {
  margin: 6px 0 0;
  color: #777880;
  font-size: 12px;
  font-weight: 600;
}

.review-task-progress {
  width: 210px;
  flex: 0 0 auto;
}

.review-task-progress__label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  color: #6d6e75;
  font-size: 12px;
  font-weight: 700;
}

.review-task-progress__label strong {
  color: #292a2e;
  font-size: 13px;
}

.review-task-progress small {
  display: block;
  margin-top: 6px;
  color: #999aa1;
  text-align: right;
  font-size: 12px;
  font-weight: 700;
}

.review-progress-track {
  height: 6px;
  overflow: hidden;
  border-radius: 999px;
  background: #e7e7e9;
}

.review-progress-track span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #e86135;
  transition: width 220ms ease;
}

.sample-workspace,
.survey-card {
  border: 1px solid #dedee1;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(20, 20, 22, 0.05);
}

.sample-workspace {
  min-width: 0;
  overflow: hidden;
}

.sample-workspace__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 20px 22px;
  border-bottom: 1px solid #e7e7e9;
}

.section-eyebrow {
  margin: 0 0 6px;
  color: #8a4a33;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.15em;
}

.sample-workspace__header h2,
.survey-card__header h2 {
  margin: 0;
  color: #202124;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.sample-workspace__header p:not(.section-eyebrow),
.survey-card__header p:not(.section-eyebrow) {
  margin: 6px 0 0;
  color: #7d7e85;
  font-size: 12px;
  line-height: 1.6;
}

.sample-navigation {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
}

.sample-navigation button {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6da;
  color: #5f6067;
  background: #fff;
  cursor: pointer;
}

.sample-navigation button:hover {
  border-color: #aaaab0;
  color: #202124;
  background: #f1f1f2;
}

.sample-navigation strong {
  min-width: 38px;
  color: #38393e;
  text-align: center;
  font-size: 12px;
}

.sample-strip {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  padding: 12px;
  border-bottom: 1px solid #e7e7e9;
  background: #f7f7f8;
}

.sample-strip button {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 9px;
  padding: 10px;
  border: 1px solid #dedee1;
  color: #6d6e75;
  text-align: left;
  background: #fff;
  cursor: pointer;
  transition: all 160ms ease;
}

.sample-strip button:hover {
  border-color: #aaaab0;
}

.sample-strip button.is-active {
  border-color: #9b9ca2;
  color: #292a2e;
  background: #eeeeef;
  box-shadow: inset 3px 0 0 #e86135;
}

.sample-strip button.is-complete .sample-strip__index {
  color: #fff;
  background: #17815f;
}

.sample-strip__index {
  display: inline-flex;
  width: 25px;
  height: 25px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #fff;
  background: #5e5f66;
  font-size: 12px;
  font-weight: 700;
}

.sample-strip__copy {
  min-width: 0;
  flex: 1;
}

.sample-strip__copy strong,
.sample-strip__copy small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sample-strip__copy strong {
  font-family: monospace;
  font-size: 12px;
}

.sample-strip__copy small {
  margin-top: 3px;
  color: #85868d;
  font-size: 12px;
}

.sample-strip button > i {
  color: #17815f;
  font-size: 12px;
}

.sample-card {
  padding: 22px;
}

.sample-card__header {
  padding-bottom: 18px;
  border-bottom: 1px solid #e7e7e9;
}

.sample-card__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-bottom: 10px;
}

.sample-card__badges span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 999px;
  padding: 5px 9px;
  font-size: 12px;
  font-weight: 700;
}

.sample-type {
  color: #fff;
  background: #303136;
}

.sample-risk {
  color: #a33d24;
  background: #fff0e9;
}

.sample-status {
  color: #1a6652;
  background: #e9f7f1;
}

.sample-card__header h2 {
  margin: 0;
  color: #202124;
  font-size: 21px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.sample-card__header p {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 8px 0 0;
  color: #777880;
  font-size: 12px;
  font-weight: 600;
}

.selection-reason {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  margin: 16px 0;
  padding: 13px 14px;
  border: 1px solid #f0d5ae;
  border-radius: 7px;
  color: #805625;
  background: #fffaf0;
}

.selection-reason > i {
  margin-top: 2px;
  color: #bd7c28;
}

.selection-reason strong {
  display: block;
  font-size: 12px;
}

.selection-reason p {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.6;
}

.qa-content,
.kg-content {
  display: grid;
  gap: 11px;
}

.review-content-block {
  border: 1px solid #dedee1;
  border-radius: 7px;
  padding: 17px;
  background: #fafafa;
}

.review-content-block.is-answer {
  border-color: #d5d5d9;
  background: #f3f3f4;
}

.review-content-block.is-evidence {
  border-color: #dedee1;
  background: #fafafa;
  box-shadow: inset 3px 0 0 #e86135;
}

.content-label {
  display: block;
  margin-bottom: 9px;
  color: #6b6c73;
  font-family: monospace;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.content-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.content-label-row small {
  color: #85868d;
  font-size: 12px;
}

.review-content-block h3,
.review-content-block p,
.review-content-block blockquote {
  margin: 0;
  color: #2f3035;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.75;
}

.review-content-block blockquote {
  color: #3f4046;
  font-size: 12px;
  font-weight: 600;
}

.kg-node-list,
.kg-relation-list {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.kg-node-list {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.kg-node-list li,
.kg-relation-list li {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 9px;
  border: 1px solid #dedee1;
  border-radius: 6px;
  padding: 10px 11px;
  color: #4f5057;
  background: #fff;
  font-size: 12px;
  font-weight: 700;
}

.kg-node-list i,
.kg-relation-list i {
  color: #c9532f;
}

.kg-relation-list code {
  overflow-wrap: anywhere;
  color: #3f4046;
  font-size: 12px;
}

.sample-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin-top: 16px;
  padding-top: 15px;
  border-top: 1px solid #e7e7e9;
  color: #85868d;
  font-size: 12px;
  font-weight: 700;
}

.sample-card__footer div {
  display: flex;
  align-items: center;
  gap: 7px;
}

.survey-panel {
  min-width: 0;
}

.survey-card {
  top: 132px;
  overflow-y: auto;
}

.survey-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 19px 20px;
  border-bottom: 1px solid #e7e7e9;
}

.survey-score {
  flex: 0 0 auto;
  text-align: right;
}

.survey-score strong,
.survey-score span {
  display: block;
}

.survey-score strong {
  color: #c9532f;
  font-size: 22px;
  font-weight: 700;
}

.survey-score span {
  margin-top: 2px;
  color: #999aa1;
  font-size: 12px;
  font-weight: 700;
}

.survey-completion {
  padding: 11px 20px;
  border-bottom: 1px solid #e7e7e9;
  background: #f7f7f8;
}

.survey-completion > div:first-child {
  display: flex;
  justify-content: space-between;
  margin-bottom: 7px;
  color: #73747b;
  font-size: 12px;
  font-weight: 700;
}

.survey-section {
  padding: 17px 20px;
  border-bottom: 1px solid #ececef;
}

.survey-section h3,
.survey-section label > strong {
  display: block;
  margin: 0;
  color: #2d2e33;
  font-size: 12px;
  font-weight: 700;
}

.survey-section > p,
.survey-section label > span {
  display: block;
  margin: 5px 0 0;
  color: #85868d;
  font-size: 12px;
  line-height: 1.5;
}

.decision-grid {
  display: grid;
  gap: 7px;
  margin-top: 11px;
}

.decision-grid button {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 11px;
  border: 1px solid #dedee1;
  color: #68768a;
  text-align: left;
  background: #fff;
  cursor: pointer;
}

.decision-grid button.is-selected {
  border-color: #9b9ca2;
  color: #202124;
  background: #eeeeef;
}

.decision-grid button > i {
  width: 17px;
  text-align: center;
}

.decision-grid span strong,
.decision-grid span small {
  display: block;
}

.decision-grid span strong {
  font-size: 12px;
}

.decision-grid span small {
  margin-top: 2px;
  color: #8b96a6;
  font-size: 12px;
}

.survey-question__title {
  display: flex;
  align-items: flex-start;
  gap: 9px;
}

.survey-question__title > span {
  display: inline-flex;
  width: 22px;
  height: 22px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  color: #fff;
  background: #55565d;
  font-size: 12px;
  font-weight: 700;
}

.survey-question__title p {
  margin: 4px 0 0;
  color: #85868d;
  font-size: 12px;
  line-height: 1.5;
}

.score-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 5px;
  margin-top: 11px;
}

.score-grid button {
  min-width: 0;
  height: 42px;
  border: 1px solid #dedee1;
  color: #73747b;
  background: #fff;
  cursor: pointer;
}

.score-grid button strong,
.score-grid button small {
  display: block;
}

.score-grid button small {
  min-height: 10px;
  margin-top: 1px;
}

.score-grid button.is-selected {
  border-color: #35363b;
  color: #fff;
  background: #35363b;
}

.issue-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
  margin-top: 11px;
}

.issue-grid button {
  display: flex;
  align-items: center;
  gap: 7px;
  min-height: 36px;
  border: 1px solid #dedee1;
  color: #67758a;
  text-align: left;
  background: #fff;
  cursor: pointer;
}

.issue-grid button.is-selected {
  border-color: #cd7b5f;
  color: #9a4026;
  background: #fff3ee;
}

.issue-grid i {
  width: 14px;
  text-align: center;
}

.survey-section label + label {
  display: block;
  margin-top: 15px;
}

.survey-section textarea {
  width: 100%;
  margin-top: 9px;
  resize: vertical;
  border: 1px solid #d7d7db;
  border-radius: 6px;
  padding: 11px 12px;
  color: #34353a;
  background: #f8f8f9;
  font: inherit;
  font-size: 12px;
  line-height: 1.6;
  outline: none;
  box-sizing: border-box;
}

.survey-section textarea:focus {
  border-color: #e86135;
  background: #fff;
  box-shadow: 0 0 0 2px rgba(232, 97, 53, 0.12);
}

.survey-actions {
  padding: 14px 20px 18px;
  background: #fff;
  box-shadow: 0 -1px 0 #e7e7e9;
}

.survey-actions p {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  margin: 0 0 9px;
  color: #137153;
  font-size: 12px;
  font-weight: 700;
}

.survey-actions button {
  display: flex;
  width: 100%;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 0;
  color: #fff;
  background: #292a2e;
  cursor: pointer;
  transition: background 160ms ease;
}

.survey-actions button:hover {
  background: #3a3b40;
}

@media (max-width: 760px) {
  .review-task-progress {
    width: 100%;
  }
  .sample-workspace__header,
  .survey-card__header {
    flex-direction: column;
  }
  .sample-strip {
    grid-template-columns: minmax(0, 1fr);
  }
  .sample-card {
    padding: 16px;
  }
  .sample-card__header h2 {
    font-size: 18px;
  }
  .kg-node-list {
    grid-template-columns: minmax(0, 1fr);
  }
}
/* Representative sample workspace: compact, non-duplicating review hierarchy */
.sample-workspace .sample-strip {
  display: grid !important;
  grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
  min-height: 72px !important;
  gap: 8px !important;
  padding: 10px 12px !important;
  overflow: visible !important;
  background: #f5f7f3 !important;
}

.sample-workspace .sample-strip button {
  min-width: 0 !important;
  min-height: 52px !important;
  display: grid !important;
  grid-template-columns: 24px minmax(0, 1fr) auto;
  align-items: center;
  gap: 9px !important;
  padding: 8px 10px !important;
  border: 1px solid transparent !important;
}

.sample-strip__number {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  border-radius: 7px;
  color: #687269;
  background: #e5e9e4;
  font-size: 12px;
  font-weight: 700;
}

.sample-strip button.is-active .sample-strip__number {
  color: #fff;
  background: var(--review-orange);
}

.sample-strip button.is-complete:not(.is-active) .sample-strip__number {
  color: #fff;
  background: var(--review-green);
}

.sample-workspace .sample-strip__copy {
  min-width: 0;
  display: block !important;
}

.sample-workspace .sample-strip__copy strong,
.sample-workspace .sample-strip__copy small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sample-workspace .sample-strip__copy strong {
  color: inherit;
  font-size: 12px;
  font-weight: 700;
}

.sample-workspace .sample-strip__copy small {
  margin-top: 4px;
  color: #7d857d;
  font-size: 12px;
  font-weight: 600;
}

.sample-workspace .sample-strip button.is-active .sample-strip__copy small {
  color: #a95a42;
}

.sample-workspace .sample-card__header {
  display: grid !important;
  grid-template-columns: minmax(190px, 0.42fr) minmax(0, 1fr);
  align-items: stretch;
  gap: 16px;
  margin: 12px 14px 0;
  padding: 14px 16px !important;
}

.sample-workspace .sample-card__heading-row {
  align-items: center !important;
}

.sample-workspace .sample-card__title-copy h2 {
  font-size: 15px;
  line-height: 1.25;
}

.sample-workspace .sample-card__title-copy > small {
  display: block;
  margin-top: 5px;
  color: #899089;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12px;
  font-weight: 700;
}

.sample-workspace .sample-card__meta {
  display: grid !important;
  grid-template-columns: minmax(180px, 1fr) minmax(120px, auto) minmax(86px, auto) !important;
  min-height: 0;
  gap: 7px;
  margin: 0;
}

.sample-workspace .sample-card__meta > span,
.sample-workspace .sample-card__meta > span:not(.sample-source),
.sample-workspace .sample-card__meta > span:last-child {
  min-width: 0;
  min-height: 48px;
  display: flex !important;
  justify-content: center;
  padding: 8px 11px;
  border: 1px solid #e6eae5;
  border-radius: 9px;
  background: #f7f9f6;
}

.sample-workspace .sample-card__meta > span.sample-source {
  justify-content: flex-start;
  color: #677168;
  background: #fff;
}

.sample-workspace .selection-reason {
  margin: 9px 14px 0;
  padding: 10px 13px !important;
}

.sample-workspace .qa-content {
  align-items: stretch;
  gap: 9px !important;
  padding: 9px 14px 14px;
}

.sample-workspace .qa-content .review-content-block {
  padding: 14px 16px 15px !important;
}

.sample-workspace .qa-content .review-content-block.is-evidence {
  grid-column: 1/-1;
}

.sample-workspace .review-content-block h3,
.sample-workspace .review-content-block p,
.sample-workspace .review-content-block blockquote {
  font-size: 12px;
  line-height: 1.65;
}

@media (max-width: 1180px) {
  .sample-workspace .sample-strip {
    display: flex !important;
    overflow-x: auto !important;
  }
  .sample-workspace .sample-strip button {
    min-width: 210px !important;
  }
  .sample-workspace .sample-card__header {
    grid-template-columns: minmax(170px, 0.35fr) minmax(0, 1fr);
  }
}
@media (max-width: 760px) {
  .sample-workspace__actions {
    align-items: stretch;
    flex-direction: column;
  }
  .sample-dataset-link,
  .sample-navigation {
    width: 100%;
    justify-content: center;
  }
  .sample-workspace .sample-card__header,
  .sample-workspace .sample-card__meta,
  .sample-workspace .qa-content {
    grid-template-columns: minmax(0, 1fr) !important;
  }
  .sample-workspace .sample-card__meta > span,
  .sample-workspace .sample-card__meta > span:not(.sample-source) {
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
  }
  .sample-workspace .qa-content .review-content-block.is-evidence {
    grid-column: auto;
  }
}
/* The review header owns one bottom divider without a second shadow line. */
.review-detail-header.reviewops-unified-header {
  border: 0 !important;
  border-bottom: 1px solid var(--review-line) !important;
  outline: 0 !important;
}

/* One review frame with straight internal dividers instead of nested cards. */
.assigned-review-detail .sample-workspace {
  border: 1px solid var(--review-line) !important;
  border-radius: 12px !important;
  background: var(--review-surface) !important;
  box-shadow: none !important;
}
.assigned-review-detail .sample-workspace__header,
.assigned-review-detail .sample-workspace .sample-strip {
  box-shadow: none !important;
}
.assigned-review-detail .sample-workspace .sample-navigation button {
  box-shadow: none !important;
}
.assigned-review-detail .sample-workspace .sample-card {
  border: 0 !important;
  border-radius: 0 !important;
  background: var(--review-surface) !important;
  box-shadow: none !important;
}
.assigned-review-detail .sample-workspace .sample-card__content {
  background: var(--review-surface) !important;
}
.assigned-review-detail .sample-workspace .sample-card__header {
  margin: 0 !important;
  padding: 18px 20px !important;
  border: 0 !important;
  border-bottom: 1px solid var(--review-line) !important;
  border-radius: 0 !important;
  background: var(--review-surface) !important;
  box-shadow: none !important;
}
.assigned-review-detail .sample-workspace .sample-card__meta {
  gap: 0 !important;
  overflow: hidden;
  border: 1px solid #e2e7e1;
  border-radius: 8px;
  background: #f8faf7;
}
.assigned-review-detail .sample-workspace .sample-card__meta > span,
.assigned-review-detail .sample-workspace .sample-card__meta > span:not(.sample-source),
.assigned-review-detail .sample-workspace .sample-card__meta > span:last-child {
  min-height: 48px;
  margin: 0 !important;
  border: 0 !important;
  border-left: 1px solid #e2e7e1 !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}
.assigned-review-detail .sample-workspace .sample-card__meta > span:first-child {
  border-left: 0 !important;
}
.assigned-review-detail .sample-workspace .selection-reason {
  margin: 0 !important;
  padding: 13px 20px !important;
  border: 0 !important;
  border-bottom: 1px solid #eadfce !important;
  border-radius: 0 !important;
  background: #fffaf1 !important;
  box-shadow: none !important;
}
.assigned-review-detail .sample-workspace .qa-content {
  gap: 0 !important;
  padding: 0 !important;
  background: var(--review-surface);
}
.assigned-review-detail .sample-workspace .qa-content .review-content-block {
  margin: 0 !important;
  padding: 18px 20px !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}
.assigned-review-detail .sample-workspace .qa-content .review-content-block.is-question {
  border-right: 1px solid var(--review-line) !important;
  border-bottom: 1px solid var(--review-line) !important;
}
.assigned-review-detail .sample-workspace .qa-content .review-content-block.is-answer {
  border-bottom: 1px solid var(--review-line) !important;
}
.assigned-review-detail .sample-workspace .qa-content .review-content-block.is-evidence {
  grid-column: 1/-1;
  background: var(--review-surface-warm) !important;
}
@media (max-width: 760px) {
  .assigned-review-detail .sample-workspace .sample-card__meta > span,
  .assigned-review-detail .sample-workspace .sample-card__meta > span:not(.sample-source),
  .assigned-review-detail .sample-workspace .sample-card__meta > span:last-child {
    border-top: 1px solid #e2e7e1 !important;
    border-left: 0 !important;
  }
  .assigned-review-detail .sample-workspace .sample-card__meta > span:first-child {
    border-top: 0 !important;
  }
  .assigned-review-detail .sample-workspace .qa-content .review-content-block.is-question {
    border-right: 0 !important;
  }
}

/* Keep the representative sample card at its content height. */
@media (min-width: 1121px) {
  .sample-workspace {
    height: auto !important;
    min-height: 0 !important;
    align-self: start;
    grid-template-rows: auto auto auto !important;
  }
  .sample-card,
  .sample-card__layout,
  .sample-card__content {
    height: auto !important;
    min-height: 0 !important;
  }
  .sample-workspace .qa-content,
  .sample-workspace .kg-content {
    min-height: 0 !important;
    flex: 0 0 auto !important;
    overflow: visible !important;
  }
}
/* Final connected-survey readability guard */
.survey-card__body .survey-question__title > div,
.survey-card__body .survey-question__title h3,
.survey-card__body .survey-question__title p,
.survey-card__body .decision-grid button > span,
.survey-card__body .decision-grid button strong,
.survey-card__body .decision-grid button small,
.survey-card__body .response-option-grid button > span,
.survey-card__body .issue-grid button > span {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

.survey-card__body .survey-question__title h3,
.survey-card__body .decision-grid button strong {
  color: #25362f !important;
}

.survey-card__body .survey-question__title p,
.survey-card__body .decision-grid button small {
  color: #707b73 !important;
}

.survey-card__body .survey-question__title > span {
  color: #fff !important;
  font-size: 12px !important;
}

.survey-card__body .response-option-grid button > span,
.survey-card__body .issue-grid button > span {
  color: inherit !important;
  white-space: normal !important;
}

.survey-card__body .decision-grid button {
  padding: 10px 12px !important;
}

.survey-card__body .response-option-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.survey-card__body .issue-grid {
  grid-template-columns: minmax(0, 1fr);
}

.survey-card__body .issue-grid button {
  min-height: 40px;
  padding: 8px 11px;
}

.response-option-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
  margin-top: 11px;
}

.response-option-grid button {
  min-width: 0;
  min-height: 38px;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 8px 10px;
  border: 1px solid #dfe4de;
  color: #687169;
  text-align: left;
  background: #fff;
  cursor: pointer;
}

.response-option-grid button:hover,
.response-option-grid button:focus-visible {
  border-color: #9eb9ae;
  color: var(--review-green-dark);
  background: var(--review-green-soft);
  outline: 0;
}

.response-option-grid button.is-selected {
  border-color: var(--review-green);
  color: #fff;
  background: var(--review-green);
  box-shadow: 0 3px 10px rgba(47, 112, 91, 0.16);
}

.response-option-grid button i {
  flex: 0 0 auto;
  font-size: 12px;
}

.response-option-grid button span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Selected concept: evidence trace workspace */
.sample-workspace {
  border: 0;
  border-radius: 0 !important;
  background: #ffffff;
  box-shadow: none !important;
}

.sample-workspace__header {
  min-height: 86px;
  align-items: center;
  padding: 18px 22px;
  border: 0;
  border-radius: 0 !important;
  background: #ffffff;
}

.sample-workspace__header .section-eyebrow {
  display: none;
}

.sample-workspace__header h2 {
  font-size: 18px;
  letter-spacing: -0.03em;
}

.sample-workspace__header p:not(.section-eyebrow) {
  margin-top: 5px;
  font-size: 12px;
}

.sample-navigation button {
  border: 0;
  box-shadow: inset 0 0 0 1px #d9d9dd !important;
}

.sample-strip {
  min-height: 68px;
  gap: 0;
  padding: 0;
  border: 0;
  background: #f6f6f7;
}

.sample-strip button {
  position: relative;
  justify-content: flex-start;
  gap: 10px;
  min-height: 68px;
  padding: 13px 18px;
  border: 0;
  color: #66676e;
  background: transparent;
  box-shadow: none !important;
}

.sample-strip button:hover {
  color: #202124;
  background: #eeeeef;
}

.sample-strip button.is-active {
  color: #ffffff;
  background: #202124;
  box-shadow: none !important;
}

.sample-strip button.is-complete .sample-strip__marker {
  background: #17815f;
}

.sample-strip__marker {
  width: 8px;
  height: 8px;
  flex: 0 0 auto;
  border-radius: 2px;
  background: #b7b8bd;
}

.sample-strip button.is-active .sample-strip__marker {
  background: #e86135;
  box-shadow: 0 0 0 2px rgba(232, 97, 53, 0.15);
}

.sample-strip__copy {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
}

.sample-strip__copy strong,
.sample-strip__copy small {
  margin: 0;
  color: inherit;
}

.sample-strip__copy strong {
  flex: 0 0 auto;
  font-size: 12px;
  letter-spacing: 0.03em;
}

.sample-strip__copy small {
  font-size: 12px;
  font-weight: 600;
}

.sample-strip button > i {
  margin-left: auto;
  color: #49a985;
}

.sample-card {
  padding: 0;
  border-radius: 0 !important;
  background: #ffffff;
}

.sample-card__content {
  min-width: 0;
  padding-top: 28px;
}

.sample-card__header {
  padding: 0 28px 18px;
  border: 0;
}

.sample-card__badges {
  margin-bottom: 12px;
}

.sample-card__header h2 {
  font-size: 21px;
}

.sample-card__header p {
  margin-top: 7px;
  font-size: 12px;
}

.selection-reason {
  display: grid;
  grid-template-columns: 20px max-content minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  margin: 0;
  padding: 17px 28px 20px;
  border: 0;
  border-radius: 0 !important;
  color: #6b4b27;
  background: #ffffff;
}

.selection-reason > i {
  margin: 0;
  color: #b96e24;
  font-size: 15px;
}

.selection-reason strong {
  font-size: 12px;
  white-space: nowrap;
}

.selection-reason p {
  margin: 0;
  color: #5f6067;
  font-size: 12px;
}

.qa-content,
.kg-content {
  gap: 0;
}

.review-content-block {
  border: 0;
  border-radius: 0 !important;
  padding: 22px 28px;
  background: #ffffff;
  box-shadow: none !important;
}

.review-content-block.is-question {
  padding-top: 21px;
  padding-bottom: 22px;
  background: #f5f5f6;
}

.review-content-block.is-answer {
  padding-top: 27px;
  padding-bottom: 21px;
  background: #ffffff;
}

.review-content-block.is-evidence {
  padding-top: 20px;
  padding-bottom: 29px;
  background: #ffffff;
  box-shadow: none !important;
}

.content-label {
  margin-bottom: 10px;
  color: #66676e;
  font-size: 12px;
  letter-spacing: 0.1em;
}

.content-label-row .content-label {
  margin-bottom: 0;
}

.content-label-row {
  margin-bottom: 10px;
}

.review-content-block h3,
.review-content-block p,
.review-content-block blockquote {
  color: #202124;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.75;
}

.review-content-block.is-answer p {
  font-size: 14px;
  font-weight: 700;
}

.review-content-block mark {
  border-radius: 2px;
  padding: 2px 3px;
  color: inherit;
  background: #ffd9c8;
}

.sample-card__rail {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 24px;
  padding: 36px 22px 28px;
  border: 0;
  border-radius: 0 !important;
  background: #f6f6f7;
}

.sample-card__rail-badges {
  display: grid;
  justify-items: start;
  gap: 9px;
}

.sample-card__rail-badges span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 999px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 700;
}

.sample-card__rail-id,
.sample-card__rail-lock {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  padding: 13px 0;
  color: #72737a;
}

.sample-card__rail-id {
  margin-top: 10px;
}

.sample-card__rail-id i,
.sample-card__rail-lock i {
  margin-top: 2px;
  color: #8b8c93;
}

.sample-card__rail-id strong {
  font-family: monospace;
  font-size: 12px;
  letter-spacing: 0.04em;
}

.sample-card__rail-lock {
  margin-top: 0;
  color: #777880;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.7;
}

.sample-card__footer {
  display: none;
}

@media (max-width: 900px) {
  .sample-card__rail {
    display: grid;
    grid-template-columns: auto auto minmax(0, 1fr);
    align-items: center;
    gap: 16px;
    padding: 16px 20px;
  }
  .sample-card__rail-badges {
    display: flex;
  }
  .sample-card__rail-id,
  .sample-card__rail-lock {
    margin: 0;
    padding: 0;
  }
}
@media (max-width: 760px) {
  .sample-strip {
    display: flex;
    overflow-x: auto;
  }
  .sample-strip button {
    min-width: 230px;
  }
  .sample-card__content {
    padding-top: 22px;
  }
  .sample-card__header,
  .selection-reason,
  .review-content-block {
    padding-right: 18px;
    padding-left: 18px;
  }
  .selection-reason {
    grid-template-columns: 18px minmax(0, 1fr);
  }
  .selection-reason p {
    grid-column: 2;
  }
  .sample-card__rail {
    grid-template-columns: minmax(0, 1fr);
  }
}
/* Combined concept: balanced review + evidence inspector toggle */
.review-detail-main {
  background: #f5f5f6;
}

.sample-workspace,
.survey-card {
  border: 0;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.sample-workspace__header {
  min-height: 82px;
  padding: 16px 22px;
}

.sample-strip {
  min-height: 50px;
}

.sample-strip button {
  min-height: 50px;
  padding: 9px 16px;
}

.sample-strip__copy {
  gap: 9px;
}

.sample-strip__copy small {
  font-size: 12px;
}

.sample-card__layout {
  background: #ffffff;
}

.sample-card__content {
  padding-top: 0;
}

.sample-card__header {
  padding: 30px 28px 20px;
}

.sample-card__heading-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.sample-card__heading-row h2 {
  min-width: 0;
  margin: 0;
  color: #202124;
  font-size: 21px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.sample-card__heading-row .sample-type {
  flex: 0 0 auto;
  border-radius: 999px;
  padding: 5px 9px;
  font-size: 12px;
  font-weight: 700;
}

.sample-card__meta {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) auto auto auto;
  align-items: stretch;
  gap: 0;
  margin-top: 17px;
}

.sample-card__meta > span {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 7px;
  padding-right: 18px;
  color: #777880;
  font-size: 12px;
  font-weight: 600;
}

.sample-card__meta > span:not(.sample-source) {
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  min-width: 90px;
  padding-left: 18px;
  background: #f8f8f9;
}

.sample-card__meta small {
  color: #94959c;
  font-size: 12px;
  font-weight: 700;
}

.sample-card__meta strong {
  font-size: 12px;
  font-weight: 700;
}

.sample-card__meta .sample-risk,
.sample-card__meta .sample-status {
  border-radius: 999px;
  padding: 5px 8px;
}

.sample-id {
  color: #55565d;
  font-family: monospace;
  letter-spacing: 0.03em;
}

.selection-reason {
  padding: 18px 28px 22px;
  background: #ffffff;
}

.review-content-block.is-question {
  min-height: 112px;
  padding: 25px 28px;
  background: #f5f5f6;
}

.review-content-block.is-answer {
  min-height: 134px;
  padding: 27px 28px;
}

.review-content-block.is-evidence {
  min-height: 158px;
  padding: 23px 28px 27px;
  background: #fffaf5;
}

.evidence-toggle,
.evidence-detail-button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 0;
  color: #6b4b35;
  background: transparent;
  box-shadow: none !important;
  cursor: pointer;
  font: inherit;
}

.evidence-toggle {
  padding: 0;
  font-family: monospace;
  letter-spacing: 0.08em;
}

.evidence-toggle:hover,
.evidence-detail-button:hover {
  color: #c9532f;
}

.evidence-detail-button {
  margin-top: 19px;
  padding: 7px 0;
  color: #9a4d30;
}

.evidence-detail-button i {
  font-size: 12px;
  transition: transform 160ms ease;
}

.evidence-detail-button:hover i {
  transform: translateX(3px);
}

.sample-card__rail {
  display: none !important;
}

.source-inspector {
  display: flex;
  min-width: 0;
  flex-direction: column;
  border: 0;
  border-radius: 0 !important;
  background: #ffffff;
}

.source-inspector__header {
  display: flex;
  min-height: 82px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 22px;
  border-radius: 0 !important;
  background: #ffffff;
}

.source-inspector__header .section-eyebrow {
  display: block;
  margin-bottom: 5px;
}

.source-inspector__header h2 {
  margin: 0;
  color: #202124;
  font-size: 17px;
  font-weight: 700;
}

.source-inspector__header button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  padding: 8px 10px;
  color: #66676e;
  background: #f0f0f1;
  box-shadow: none !important;
  cursor: pointer;
}

.source-inspector__header button:hover {
  color: #202124;
  background: #e6e6e8;
}

.source-inspector__meta {
  display: grid;
  gap: 8px;
  padding: 17px 22px;
  color: #777880;
  background: #f7f7f8;
  font-size: 12px;
}

.source-inspector__meta span {
  display: flex;
  align-items: center;
  gap: 7px;
}

.source-inspector__meta strong {
  color: #66676e;
  font-family: monospace;
  font-size: 12px;
}

.source-inspector__body {
  flex: 1;
  padding: 29px 22px;
}

.source-inspector__body blockquote {
  margin: 0;
  color: #2f3035;
  font-size: 13px;
  font-weight: 600;
  line-height: 2;
}

.source-inspector__body mark {
  border-radius: 2px;
  padding: 2px 3px;
  color: inherit;
  background: #ffd9c8;
}

.source-inspector__footer {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: start;
  gap: 8px;
  padding: 18px 22px;
  color: #85868d;
  background: #fafafa;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.6;
}

.source-inspector__footer strong {
  color: #66676e;
  font-family: monospace;
  font-size: 12px;
}

.review-detail-main.is-evidence-open .sample-workspace .sample-card__header {
  grid-template-columns: minmax(0, 1fr) !important;
  gap: 12px !important;
  padding-top: 16px !important;
}

.review-detail-main.is-evidence-open .sample-workspace .sample-card__heading-row,
.review-detail-main.is-evidence-open .sample-workspace .sample-card__title-copy {
  min-width: 0;
}

.review-detail-main.is-evidence-open .sample-workspace .sample-card__meta {
  width: 100%;
  grid-template-columns: minmax(0, 1fr) minmax(120px, auto) minmax(88px, auto) !important;
  gap: 7px !important;
}

.review-detail-main.is-evidence-open .sample-workspace .sample-card__meta > span,
.review-detail-main.is-evidence-open .sample-workspace .sample-card__meta > span:not(.sample-source) {
  min-width: 0;
  flex-direction: row;
  align-items: center;
  gap: 7px;
  padding: 8px 10px;
  overflow-wrap: anywhere;
}

.review-detail-main.is-evidence-open .sample-workspace .sample-card__meta > span:not(.sample-source) {
  display: flex !important;
}

.review-detail-main.is-evidence-open .selection-reason {
  grid-template-columns: 18px minmax(0, 1fr);
  padding-top: 14px;
  padding-bottom: 18px;
  background: #f7f7f8;
}

.review-detail-main.is-evidence-open .selection-reason p {
  grid-column: 2;
}

.review-detail-main.is-evidence-open .review-content-block.is-question,
.review-detail-main.is-evidence-open .review-content-block.is-answer {
  min-height: 0;
}

.review-detail-main.is-evidence-open .sample-workspace .qa-content,
.review-detail-main.is-evidence-open .sample-workspace .kg-content {
  grid-template-columns: minmax(0, 1fr) !important;
}

.review-detail-main.is-evidence-open .sample-workspace .review-content-block,
.review-detail-main.is-evidence-open .source-inspector__body blockquote {
  overflow-wrap: anywhere;
  word-break: keep-all;
}

.survey-card {
  top: 92px;
}

@media (max-width: 1260px) {
  .sample-card__meta {
    grid-template-columns: minmax(0, 1fr) auto auto;
  }
  .sample-card__meta > span:last-child {
    display: none;
  }
}
@media (max-width: 820px) {
  .sample-card__meta {
    grid-template-columns: minmax(0, 1fr);
    gap: 9px;
  }
  .sample-card__meta > span,
  .sample-card__meta > span:not(.sample-source) {
    min-width: 0;
    flex-direction: row;
    align-items: center;
    padding: 0;
    background: transparent;
  }
}
@media (max-width: 760px) {
  .sample-workspace__header {
    min-height: auto;
  }
  .sample-card__heading-row {
    align-items: flex-start;
  }
  .sample-card__header,
  .selection-reason,
  .review-content-block {
    padding-right: 18px;
    padding-left: 18px;
  }
}
/* Fixed review viewport and compact sample identity */
:host {
  height: 100%;
  min-height: 0;
  overflow: hidden !important;
}

.assigned-review-detail {
  display: flex;
  height: 100%;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
}

.sample-workspace {
  display: grid;
  height: 100%;
  min-height: 0;
  grid-template-rows: auto auto minmax(0, 1fr);
  overflow: hidden;
}

.sample-card {
  min-height: 0;
}

.sample-card__content {
  display: flex;
  height: 100%;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
}

.sample-card__heading-row {
  justify-content: flex-start;
  gap: 12px;
}

.sample-card__heading-row .sample-type {
  display: inline-flex;
  min-width: 38px;
  height: 28px;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  border-radius: 5px !important;
  padding: 0 9px;
  color: #ffffff;
  background: #303136;
  font-size: 12px;
  letter-spacing: 0.02em;
}

.sample-card__title-copy {
  min-width: 0;
}

.sample-card__title-kicker {
  margin: 0 0 5px;
  color: #9a9ba2;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.11em;
}

.sample-card__meta {
  grid-template-columns: minmax(230px, 1fr) repeat(3, minmax(92px, auto));
  min-height: 58px;
  margin-top: 20px;
  background: #f5f5f6;
}

.sample-card__meta > span,
.sample-card__meta > span:not(.sample-source) {
  justify-content: center;
  padding: 11px 16px;
  background: transparent;
}

.sample-card__meta > span.sample-source {
  justify-content: flex-start;
  padding-left: 0;
  color: #6f7077;
  background: #ffffff;
}

.sample-card__meta .sample-risk,
.sample-card__meta .sample-status {
  border-radius: 0 !important;
  padding: 0;
  background: transparent;
}

.sample-card__meta .sample-risk {
  color: #b5482a;
}

.sample-card__meta .sample-status {
  color: #167153;
}

.qa-content,
.kg-content {
  min-height: 0;
  flex: 1 1 auto;
  overflow: hidden;
}

.qa-content {
  display: grid;
  grid-template-rows: minmax(82px, auto) minmax(96px, auto) minmax(106px, 1fr);
}

.review-content-block {
  min-height: 0 !important;
  overflow: hidden;
}

.source-inspector {
  height: 100%;
  overflow: hidden;
}

.source-inspector__body {
  min-height: 0;
}

.survey-panel {
  min-height: 0;
}

.survey-card {
  top: auto;
  display: grid;
  min-height: 0;
  grid-template-rows: auto auto minmax(0, 1fr) auto;
}

.survey-card__body {
  min-height: 0;
  overflow-x: hidden;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}

.survey-card__body::-webkit-scrollbar {
  width: 8px;
}

.survey-card__body::-webkit-scrollbar-track {
  background: #f1f1f2;
}

.survey-card__body::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: #b5b5ba;
}

.survey-actions {
  flex: 0 0 auto;
}

@media (max-height: 760px) and (min-width: 1081px) {
  .sample-workspace__header {
    min-height: 64px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .sample-card__header {
    padding-top: 18px;
    padding-bottom: 12px;
  }
  .selection-reason {
    padding-top: 12px;
    padding-bottom: 14px;
  }
  .review-content-block.is-question,
  .review-content-block.is-answer,
  .review-content-block.is-evidence {
    padding-top: 15px;
    padding-bottom: 15px;
  }
}
@media (max-width: 1080px) {
  :host {
    overflow-y: auto !important;
  }
  .assigned-review-detail {
    height: auto;
    min-height: 100%;
    overflow: visible;
  }
  .sample-workspace,
  .survey-panel,
  .survey-card {
    height: auto;
    overflow: visible;
  }
}
/* Aggregate survey workflow */
.sample-strip button.is-complete:not(.is-active) {
  color: #276c57;
  background: #eef7f3;
}

.sample-strip button.is-complete:not(.is-active) .sample-strip__marker {
  background: #26785e;
}

.survey-gate {
  display: flex;
  min-height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 34px 28px;
  text-align: center;
  background: #f7f7f8;
  box-sizing: border-box;
}

.survey-gate__icon {
  display: inline-flex;
  width: 46px;
  height: 46px;
  align-items: center;
  justify-content: center;
  margin-bottom: 17px;
  border-radius: 7px;
  color: #ffffff;
  background: #303136;
  font-size: 17px;
}

.survey-gate .section-eyebrow {
  margin-bottom: 8px;
}

.survey-gate h3 {
  margin: 0;
  color: #292a2e;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.survey-gate > p:not(.section-eyebrow) {
  max-width: 290px;
  margin: 9px 0 0;
  color: #777880;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.7;
}

.survey-gate__progress {
  display: grid;
  width: min(100%, 280px);
  grid-template-columns: minmax(0, 1fr) 36px;
  align-items: center;
  gap: 10px;
  margin-top: 22px;
}

.survey-gate__progress strong {
  color: #55565d;
  font-size: 12px;
  font-weight: 700;
}

.review-load-error {
  grid-column: 1/-1;
  min-height: 280px;
}

.review-load-error > button {
  margin-top: 18px;
  border: 0;
  padding: 11px 16px;
  color: #fff;
  background: #334d3d;
  cursor: pointer;
}

.survey-actions button:disabled {
  color: #8a8b91;
  background: #e7e7e9;
  cursor: not-allowed;
}

/* Premium review workspace ------------------------------------------------- */
:host {
  --review-bg: #f1f3ef;
  --review-surface: #ffffff;
  --review-surface-soft: #f7f8f5;
  --review-surface-warm: #fff8f3;
  --review-line: #dfe4dc;
  --review-line-strong: #cfd7cd;
  --review-ink: #242924;
  --review-muted: #747d74;
  --review-faint: #9aa19a;
  --review-green: #2f705b;
  --review-green-dark: #245645;
  --review-green-soft: #eaf4ef;
  --review-orange: #df5a32;
  --review-orange-soft: #fff0e9;
  --review-amber: #b77721;
  --review-shadow: 0 12px 34px rgba(35, 46, 37, .07);
  color: var(--review-ink);
  background: var(--review-bg);
}

.assigned-review-detail {
  background: linear-gradient(180deg, #f8f9f6 0, var(--review-bg) 170px) !important;
}

.review-detail-header {
  z-index: 30;
  border-bottom: 1px solid var(--review-line) !important;
  background: rgba(255, 255, 255, 0.96) !important;
  backdrop-filter: blur(18px);
}

.review-detail-heading {
  align-items: center;
  gap: 16px;
}

.review-back-link {
  width: 42px;
  height: 42px;
  border: 1px solid var(--review-line-strong);
  border-radius: 12px;
  color: #596359;
  background: var(--review-surface);
  box-shadow: 0 3px 12px rgba(35, 46, 37, 0.05);
}

.review-back-link:hover,
.review-back-link:focus-visible {
  border-color: #aab8ac;
  color: var(--review-green-dark);
  background: #f5f8f5;
  box-shadow: 0 0 0 4px rgba(47, 112, 91, 0.1);
  outline: 0;
  transform: translateX(-2px);
}

.review-detail-heading__meta {
  gap: 8px;
  margin-bottom: 6px;
  color: var(--review-muted);
  font-size: 12px;
}

.review-detail-heading__meta > span:not(.review-kind-badge) {
  position: relative;
  padding-left: 10px;
}

.review-detail-heading__meta > span:not(.review-kind-badge)::before {
  position: absolute;
  top: 50%;
  left: 0;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #a9afa8;
  content: "";
  transform: translateY(-50%);
}

.review-kind-badge {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 6px 10px;
  color: #fff !important;
  -webkit-text-fill-color: #fff;
  background: var(--review-orange) !important;
  box-shadow: 0 4px 12px rgba(223, 90, 50, 0.18);
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.review-detail-heading p {
  margin-top: 7px;
  color: var(--review-muted);
  font-size: 12px;
}

.review-task-progress {
  width: 238px;
  padding: 13px 15px;
  border: 1px solid var(--review-line);
  border-radius: 13px;
  background: var(--review-surface-soft);
}

.review-task-progress__label {
  margin-bottom: 9px;
  color: var(--review-muted);
  font-size: 12px;
}

.review-task-progress__label strong {
  color: var(--review-green-dark);
  font-size: 14px;
}

.review-progress-track {
  height: 7px;
  background: #e1e6df;
}

.review-progress-track span {
  background: linear-gradient(90deg, var(--review-orange), #ef7d55);
  box-shadow: 0 2px 7px rgba(223, 90, 50, 0.2);
}

.review-task-progress small {
  margin-top: 7px;
  color: var(--review-green);
  font-size: 12px;
}

.review-task-progress small.review-task-progress__error {
  color: #b7422d;
}

.review-detail-main {
  box-sizing: border-box;
  background: transparent !important;
}

.sample-workspace,
.survey-card {
  border: 1px solid var(--review-line) !important;
  border-radius: 17px !important;
  background: var(--review-surface) !important;
  box-shadow: var(--review-shadow) !important;
}

.sample-workspace {
  overflow: hidden;
}

.sample-workspace__header {
  min-height: 82px;
  padding: 17px 21px !important;
  border-bottom: 1px solid #edf0eb !important;
  background: var(--review-surface) !important;
}

.sample-workspace__header h2 {
  color: var(--review-ink);
  font-size: 18px;
  font-weight: 700;
}

.sample-workspace__header p:not(.section-eyebrow) {
  margin-top: 5px;
  color: var(--review-muted);
  font-size: 12px;
}

.sample-workspace__actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 9px;
}

.sample-dataset-link {
  min-height: 42px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0 12px;
  border: 1px solid #cbd8d2;
  border-radius: 10px;
  color: #376658;
  background: #fff;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  transition: border-color 150ms ease, color 150ms ease, background 150ms ease;
}

.sample-dataset-link em {
  min-width: 24px;
  padding: 3px 6px;
  border-radius: 999px;
  color: #fff;
  background: #3f7162;
  font-size: 12px;
  font-style: normal;
  text-align: center;
}

.sample-dataset-link:hover,
.sample-dataset-link:focus-visible {
  border-color: var(--review-green);
  color: #fff;
  background: var(--review-green);
  outline: 0;
}

.sample-navigation {
  gap: 8px;
  padding: 5px;
  border: 1px solid var(--review-line);
  border-radius: 12px;
  background: var(--review-surface-soft);
}

.sample-navigation button {
  width: 32px;
  height: 32px;
  border: 0 !important;
  color: #657065;
  background: #fff;
  box-shadow: 0 1px 4px rgba(31, 42, 34, 0.08) !important;
}

.sample-navigation button:hover,
.sample-navigation button:focus-visible {
  color: #fff;
  background: var(--review-green);
  box-shadow: 0 0 0 3px rgba(47, 112, 91, 0.12) !important;
  outline: 0;
}

.sample-navigation strong {
  min-width: 44px;
  color: var(--review-ink);
  font-size: 12px;
}

.sample-strip {
  min-height: 62px;
  gap: 8px;
  padding: 9px 10px;
  border-bottom: 1px solid var(--review-line) !important;
  background: #f5f7f3 !important;
}

.sample-strip button {
  min-height: 44px;
  padding: 9px 12px;
  border: 1px solid transparent !important;
  color: #667066;
  background: transparent;
}

.sample-strip button:hover {
  border-color: #dae1d8 !important;
  color: var(--review-ink);
  background: #fff;
}

.sample-strip button.is-active {
  border-color: #f0b39e !important;
  color: #9b3f25;
  background: var(--review-orange-soft);
  box-shadow: 0 4px 12px rgba(223, 90, 50, 0.09) !important;
}

.sample-strip button.is-complete:not(.is-active) {
  border-color: #cfe2d8 !important;
  color: var(--review-green-dark);
  background: var(--review-green-soft);
}

.sample-strip__marker {
  width: 9px;
  height: 9px;
  border-radius: 3px;
  background: #aeb5ad;
}

.sample-strip button.is-active .sample-strip__marker {
  background: var(--review-orange);
  box-shadow: 0 0 0 3px rgba(223, 90, 50, 0.13);
}

.sample-strip button.is-complete:not(.is-active) .sample-strip__marker {
  background: var(--review-green);
}

.sample-strip__copy {
  gap: 9px;
}

.sample-strip__copy strong {
  font-size: 12px;
  font-weight: 700;
}

.sample-strip__copy small {
  font-size: 12px;
}

.sample-card {
  min-height: 0;
  background: #f7f8f5 !important;
  scrollbar-color: #bac3b8 transparent;
  scrollbar-width: thin;
}

.sample-card__layout {
  background: transparent !important;
}

.sample-card__content {
  height: auto;
  min-height: 100%;
  overflow: visible !important;
  background: transparent;
}

.sample-card__header {
  margin: 16px 16px 0;
  padding: 19px 20px !important;
  border: 1px solid var(--review-line) !important;
  border-radius: 14px !important;
  background: var(--review-surface) !important;
  box-shadow: 0 6px 18px rgba(36, 48, 39, 0.04);
}

.sample-card__heading-row {
  align-items: flex-start;
  gap: 13px;
}

.sample-card__heading-row .sample-type {
  min-width: 40px;
  height: 32px;
  border-radius: 9px !important;
  color: #fff;
  background: var(--review-green-dark);
  box-shadow: 0 4px 12px rgba(36, 86, 69, 0.17);
  font-size: 12px;
}

.sample-card__title-kicker {
  margin-bottom: 5px;
  color: var(--review-orange);
  font-size: 12px;
  letter-spacing: 0.16em;
}

.sample-card__heading-row h2 {
  color: var(--review-ink);
  font-size: 21px;
  font-weight: 700;
  line-height: 1.3;
}

.sample-card__meta {
  grid-template-columns: minmax(230px, 1fr) repeat(3, minmax(90px, auto));
  min-height: 0;
  gap: 7px;
  margin-top: 16px;
  background: transparent;
}

.sample-card__meta > span,
.sample-card__meta > span:not(.sample-source) {
  min-height: 48px;
  justify-content: center;
  padding: 8px 11px;
  border: 1px solid #e8ebe6;
  border-radius: 10px;
  background: var(--review-surface-soft);
}

.sample-card__meta > span.sample-source {
  justify-content: flex-start;
  padding: 8px 12px;
  color: var(--review-muted);
  background: #fff;
}

.sample-card__meta small {
  color: var(--review-faint);
  font-size: 12px;
}

.sample-card__meta strong {
  font-size: 12px;
}

.sample-card__meta .sample-risk {
  color: #b44b2d;
}

.sample-card__meta .sample-status {
  color: var(--review-green);
}

.selection-reason {
  grid-template-columns: 24px max-content minmax(0, 1fr);
  gap: 10px;
  margin: 12px 16px 0;
  padding: 13px 15px !important;
  border: 1px solid #ead7bb !important;
  border-radius: 12px !important;
  color: #754e20;
  background: #fffaf1 !important;
}

.selection-reason > i {
  color: var(--review-amber);
  font-size: 14px;
}

.selection-reason strong {
  font-size: 12px;
}

.selection-reason p {
  color: #6b655d;
  font-size: 12px;
  line-height: 1.65;
}

.qa-content,
.kg-content {
  display: grid;
  min-height: auto;
  flex: 0 0 auto;
  grid-template-rows: none !important;
  gap: 10px !important;
  padding: 12px 16px 18px;
  overflow: visible !important;
}

.review-content-block {
  position: relative;
  min-height: 0 !important;
  overflow: visible !important;
  border: 1px solid var(--review-line) !important;
  border-radius: 13px !important;
  padding: 17px 18px 18px !important;
  background: var(--review-surface) !important;
  box-shadow: 0 5px 16px rgba(37, 49, 39, 0.035) !important;
}

.review-content-block::before {
  position: absolute;
  top: 16px;
  bottom: 16px;
  left: 0;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: #cfd6ce;
  content: "";
}

.review-content-block.is-question {
  background: #f9faf8 !important;
}

.review-content-block.is-question::before {
  background: var(--review-green);
}

.review-content-block.is-answer::before {
  background: var(--review-orange);
}

.review-content-block.is-evidence {
  border-color: #eadccf !important;
  background: var(--review-surface-warm) !important;
}

.review-content-block.is-evidence::before {
  background: #b77a4b;
}

.content-label {
  margin-bottom: 10px;
  color: var(--review-green);
  font-size: 12px;
  letter-spacing: 0.15em;
}

.is-answer .content-label {
  color: var(--review-orange);
}

.review-content-block h3,
.review-content-block p,
.review-content-block blockquote {
  color: #303630;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.75;
}

.review-content-block.is-answer p {
  font-size: 14px;
  font-weight: 700;
}

.review-content-block mark,
.source-inspector__body mark {
  border-radius: 4px;
  padding: 2px 4px;
  color: #6f341f;
  background: #ffddce;
  box-decoration-break: clone;
  -webkit-box-decoration-break: clone;
}

.evidence-toggle,
.evidence-detail-button {
  color: #8b5839;
}

.evidence-toggle:hover,
.evidence-detail-button:hover {
  color: var(--review-orange);
}

.evidence-detail-button {
  margin-top: 15px;
  padding: 8px 11px;
  border: 1px solid #ead8ca;
  background: #fff;
}

.source-inspector {
  border-right: 1px solid var(--review-line) !important;
  background: #fbfcfa !important;
}

.source-inspector__header {
  min-height: 76px;
  padding: 16px 18px;
  border-bottom: 1px solid var(--review-line);
  background: #fff !important;
}

.source-inspector__header button {
  color: #616a61;
  background: #f1f4f0;
}

.source-inspector__meta {
  background: #f2f5f1;
}

.survey-panel {
  padding: 0;
}

.survey-card__header {
  min-height: 92px;
  padding: 18px 19px;
  border-bottom: 1px solid #dce6df;
  background: linear-gradient(135deg, #f4faf7 0%, #ffffff 72%);
}

.survey-card__header .section-eyebrow {
  margin-bottom: 6px;
  color: var(--review-green);
  font-size: 12px;
  letter-spacing: 0.18em;
}

.survey-card__header h2 {
  color: var(--review-ink);
  font-size: 17px;
  font-weight: 700;
}

.survey-card__header p:not(.section-eyebrow) {
  color: var(--review-muted);
  font-size: 12px;
}

.survey-score {
  min-width: 64px;
  padding: 9px 10px;
  border: 1px solid #d7e5dc;
  border-radius: 11px;
  background: #fff;
  text-align: center;
}

.survey-score strong {
  color: var(--review-green-dark);
  font-size: 20px;
}

.survey-score span {
  color: var(--review-faint);
  font-size: 12px;
}

.survey-completion {
  padding: 11px 18px 12px;
  border-bottom: 1px solid var(--review-line);
  background: #f5f7f4;
}

.survey-completion > div:first-child {
  margin-bottom: 8px;
  color: var(--review-muted);
}

.survey-card__body {
  background: #fbfcfa;
  scrollbar-color: #b8c2b7 transparent;
  scrollbar-width: thin;
}

.survey-section {
  margin: 10px 11px 0;
  padding: 15px 15px 16px;
  border: 1px solid var(--review-line);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(36, 48, 39, 0.03);
}

.survey-section:last-child {
  margin-bottom: 11px;
}

.survey-section h3,
.survey-section label > strong {
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
}

.survey-section > p,
.survey-section label > span,
.survey-question__title p {
  color: var(--review-muted);
  font-size: 12px;
}

.decision-grid {
  gap: 7px;
  margin-top: 11px;
}

.decision-grid button {
  min-height: 48px;
  border: 1px solid var(--review-line);
  color: #66756c;
  background: #fff;
  transition: border-color 150ms ease, color 150ms ease, background 150ms ease, transform 150ms ease;
}

.decision-grid button:hover {
  border-color: #b8c6bb;
  background: #f7faf7;
  transform: translateY(-1px);
}

.decision-grid button.is-selected {
  border-color: var(--review-green);
  color: var(--review-green-dark);
  background: var(--review-green-soft);
  box-shadow: 0 0 0 3px rgba(47, 112, 91, 0.09);
}

.decision-grid button:nth-child(2).is-selected {
  border-color: #d39438;
  color: #86570f;
  background: #fff7e8;
  box-shadow: 0 0 0 3px rgba(211, 148, 56, 0.1);
}

.decision-grid button:nth-child(3).is-selected {
  border-color: #bf6854;
  color: #8e3e2d;
  background: #fff0ec;
  box-shadow: 0 0 0 3px rgba(191, 104, 84, 0.1);
}

.survey-question__title > span {
  width: 24px;
  height: 24px;
  border-radius: 8px;
  color: #fff;
  background: var(--review-green-dark);
  box-shadow: 0 3px 9px rgba(36, 86, 69, 0.16);
}

.score-grid {
  gap: 6px;
  margin-top: 11px;
}

.score-grid button {
  height: 44px;
  border: 1px solid var(--review-line);
  color: #737c73;
  background: #f9faf8;
  transition: all 140ms ease;
}

.score-grid button:hover {
  border-color: #aebcaf;
  color: var(--review-green-dark);
  background: #fff;
  transform: translateY(-1px);
}

.score-grid button.is-selected {
  border-color: var(--review-green-dark);
  color: #fff;
  background: var(--review-green-dark);
  box-shadow: 0 5px 12px rgba(36, 86, 69, 0.18);
}

.issue-grid {
  gap: 7px;
}

.issue-grid button {
  min-height: 38px;
  padding: 0 10px;
  border: 1px solid var(--review-line);
  color: #687268;
  background: #fafbf9;
}

.issue-grid button:hover {
  border-color: #d5a28e;
  color: #9a452d;
  background: #fff8f4;
}

.issue-grid button.is-selected {
  border-color: #d8876c;
  color: #943f28;
  background: var(--review-orange-soft);
  box-shadow: 0 0 0 3px rgba(223, 90, 50, 0.08);
}

.survey-section textarea {
  min-height: 88px;
  border: 1px solid var(--review-line);
  border-radius: 10px;
  color: var(--review-ink);
  background: #f8faf7;
}

.survey-section textarea:hover {
  border-color: #bfc9be;
}

.survey-section textarea:focus {
  border-color: var(--review-green);
  background: #fff;
  box-shadow: 0 0 0 3px rgba(47, 112, 91, 0.1);
}

.survey-actions {
  padding: 12px 13px 14px;
  border-top: 1px solid var(--review-line);
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 -9px 24px rgba(37, 49, 39, 0.055);
  backdrop-filter: blur(12px);
}

.survey-actions button {
  min-height: 48px;
  color: #fff;
  background: var(--review-green-dark);
  box-shadow: 0 7px 18px rgba(36, 86, 69, 0.2);
}

.survey-actions button:hover {
  background: var(--review-green);
  transform: translateY(-1px);
}

.survey-actions button:disabled {
  color: #8a938a;
  background: #e7ebe5;
  box-shadow: none;
  transform: none;
}

.survey-gate {
  margin: 12px;
  min-height: calc(100% - 24px);
  border: 1px dashed #cbd6cc;
  border-radius: 14px;
  background: #f6f9f6;
}

.survey-gate__icon {
  border-radius: 12px;
  background: var(--review-green-dark);
  box-shadow: 0 7px 18px rgba(36, 86, 69, 0.18);
}

.survey-gate h3 {
  color: var(--review-ink);
}

@media (max-width: 1320px) {
  .sample-card__meta {
    grid-template-columns: minmax(220px, 1fr) repeat(2, minmax(88px, auto));
  }
  .sample-card__meta > span:last-child {
    display: none;
  }
}
@media (max-width: 1120px) {
  :host {
    overflow-y: auto !important;
  }
  .assigned-review-detail {
    height: auto;
    min-height: 100%;
    overflow: visible;
  }
  .sample-workspace,
  .survey-panel,
  .survey-card {
    height: auto;
    overflow: visible !important;
  }
}
@media (max-width: 760px) {
  .review-detail-heading {
    align-items: flex-start;
  }
  .review-task-progress {
    width: 100%;
    box-sizing: border-box;
  }
  .sample-workspace,
  .survey-card {
    border-radius: 14px !important;
  }
  .sample-workspace__header {
    align-items: stretch;
    flex-direction: column;
  }
  .sample-workspace__actions {
    width: 100%;
    justify-content: space-between;
  }
  .sample-dataset-link {
    min-width: 0;
  }
  .sample-strip {
    display: flex;
    overflow-x: auto;
  }
  .sample-strip button {
    min-width: 220px;
  }
  .sample-card__header {
    margin: 10px 10px 0;
    padding: 16px !important;
  }
  .sample-card__meta {
    grid-template-columns: minmax(0, 1fr);
  }
  .sample-card__meta > span,
  .sample-card__meta > span:not(.sample-source),
  .sample-card__meta > span.sample-source {
    min-height: 38px;
    justify-content: flex-start;
    flex-direction: row;
    padding: 7px 9px;
  }
  .sample-card__meta > span:last-child {
    display: flex;
  }
  .selection-reason {
    grid-template-columns: 20px minmax(0, 1fr);
    margin: 9px 10px 0;
  }
  .selection-reason p {
    grid-column: 2;
  }
  .qa-content,
  .kg-content {
    padding: 9px 10px 12px;
  }
  .review-content-block {
    padding: 15px !important;
  }
  .review-detail-main.is-evidence-open .sample-card__layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .score-grid {
    gap: 4px;
  }
  .issue-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
/* Final representative-review layout cascade */
.sample-workspace .sample-strip {
  display: grid !important;
  grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
  min-height: 72px !important;
  gap: 8px !important;
  padding: 10px 12px !important;
  overflow: visible !important;
}

.sample-workspace .sample-strip button {
  min-width: 0 !important;
  min-height: 52px !important;
  display: grid !important;
  grid-template-columns: 24px minmax(0, 1fr) auto !important;
  align-items: center;
  gap: 9px !important;
  padding: 8px 10px !important;
}

.sample-workspace .sample-strip__number {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  border-radius: 7px;
  color: #687269;
  background: #e5e9e4;
  font-size: 12px;
  font-weight: 700;
}

.sample-workspace .sample-strip button.is-active .sample-strip__number {
  color: #fff;
  background: var(--review-orange);
}

.sample-workspace .sample-strip button.is-complete:not(.is-active) .sample-strip__number {
  color: #fff;
  background: var(--review-green);
}

.sample-workspace .sample-strip__copy {
  min-width: 0;
  display: block !important;
}

.sample-workspace .sample-strip__copy strong,
.sample-workspace .sample-strip__copy small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sample-workspace .sample-strip__copy strong {
  font-size: 12px;
}

.sample-workspace .sample-strip__copy small {
  margin-top: 4px;
  font-size: 12px;
}

.sample-workspace .sample-card__header {
  display: grid !important;
  grid-template-columns: minmax(210px, 0.42fr) minmax(0, 1fr) !important;
  align-items: stretch;
  gap: 16px !important;
  margin: 12px 14px 0;
  padding: 14px 16px !important;
}

.sample-workspace .sample-card__heading-row {
  align-items: center !important;
}

.sample-workspace .sample-card__title-copy h2 {
  font-size: 15px;
  line-height: 1.25;
}

.sample-workspace .sample-card__title-copy > small {
  display: block;
  margin-top: 5px;
  overflow: hidden;
  color: #899089;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sample-workspace .sample-card__meta {
  display: grid !important;
  grid-template-columns: minmax(180px, 1fr) minmax(130px, auto) minmax(96px, auto) !important;
  min-height: 0;
  gap: 7px;
  margin: 0;
}

.sample-workspace .sample-card__meta > span,
.sample-workspace .sample-card__meta > span:not(.sample-source),
.sample-workspace .sample-card__meta > span:last-child {
  min-width: 0;
  min-height: 48px;
  display: flex !important;
  justify-content: center;
  padding: 8px 11px;
}

.sample-workspace .sample-card__meta > span.sample-source {
  justify-content: flex-start;
}

.sample-workspace .selection-reason {
  margin: 9px 14px 0;
  padding: 10px 13px !important;
}

.sample-workspace .qa-content {
  align-items: stretch;
  gap: 9px !important;
  padding: 9px 14px 14px;
}

.sample-workspace .qa-content .review-content-block {
  padding: 14px 16px 15px !important;
}

.sample-workspace .qa-content .review-content-block.is-evidence {
  grid-column: 1/-1;
}

.sample-workspace .review-content-block h3,
.sample-workspace .review-content-block p,
.sample-workspace .review-content-block blockquote {
  font-size: 12px;
  line-height: 1.65;
}

@media (max-width: 1180px) {
  .sample-workspace .sample-strip {
    display: flex !important;
    overflow-x: auto !important;
  }
  .sample-workspace .sample-strip button {
    min-width: 210px !important;
  }
  .sample-workspace .sample-card__header {
    grid-template-columns: minmax(170px, 0.35fr) minmax(0, 1fr) !important;
  }
}
@media (max-width: 760px) {
  .sample-workspace__actions {
    align-items: stretch;
    flex-direction: column;
  }
  .sample-workspace .sample-dataset-link,
  .sample-workspace .sample-navigation {
    width: 100%;
    justify-content: center;
  }
  .sample-workspace .sample-card__header,
  .sample-workspace .sample-card__meta,
  .sample-workspace .qa-content {
    grid-template-columns: minmax(0, 1fr) !important;
  }
  .sample-workspace .sample-card__meta > span,
  .sample-workspace .sample-card__meta > span:not(.sample-source) {
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
  }
  .sample-workspace .qa-content .review-content-block.is-evidence {
    grid-column: auto;
  }
}
/* 11: workspace information hierarchy and shared component roles. */
:host-context(.reviewops-shell) .assigned-review-detail .review-detail-main {
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(360px, 0.85fr);
  align-items: start;
  gap: 24px;
}
:host-context(.reviewops-shell) .assigned-review-detail .sample-workspace, :host-context(.reviewops-shell) .assigned-review-detail .survey-panel {
  min-width: 0;
  width: 100%;
}
:host-context(.reviewops-shell) .assigned-review-detail .sample-workspace {
  padding: 16px;
}
:host-context(.reviewops-shell) .assigned-review-detail .sample-workspace__header {
  flex-wrap: wrap;
  gap: 16px;
}
:host-context(.reviewops-shell) .assigned-review-detail .sample-card__layout {
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: 0;
}
:host-context(.reviewops-shell) .assigned-review-detail .sample-card {
  height: auto;
  max-height: none;
  overflow: visible;
}
:host-context(.reviewops-shell) .assigned-review-detail .source-inspector {
  min-height: 0;
}
:host-context(.reviewops-shell) .assigned-review-detail .sample-workspace .qa-content {
  display: block;
}
:host-context(.reviewops-shell) .assigned-review-detail .source-inspector {
  width: 100%;
  max-width: none;
  border: 0;
  border-bottom: 1px solid var(--ro-line);
}
:host-context(.reviewops-shell) .assigned-review-detail .source-inspector__body {
  max-height: none;
  overflow: visible;
  padding: 16px;
}
:host-context(.reviewops-shell) .assigned-review-detail .sample-card__content {
  min-width: 0;
  padding: 16px;
}
:host-context(.reviewops-shell) .assigned-review-detail .sample-workspace .sample-card__meta {
  display: flex !important;
  flex-wrap: wrap;
}
:host-context(.reviewops-shell) .assigned-review-detail .sample-workspace .sample-card__header {
  display: block !important;
}
:host-context(.reviewops-shell) .assigned-review-detail .sample-workspace .sample-card__title-copy > small {
  overflow: visible;
  white-space: normal;
  text-overflow: clip;
}
:host-context(.reviewops-shell) .assigned-review-detail .sample-workspace .review-content-block h3 {
  font-size: 16px;
  line-height: 26px;
}
:host-context(.reviewops-shell) .assigned-review-detail .sample-card__title-copy {
  min-width: 0;
}
:host-context(.reviewops-shell) .assigned-review-detail .sample-card__title-copy small {
  white-space: normal;
}
:host-context(.reviewops-shell) .assigned-review-detail .review-content-block {
  padding: 16px 0;
}
:host-context(.reviewops-shell) .assigned-review-detail .review-content-block h3 {
  font-size: 16px;
  line-height: 26px;
}
:host-context(.reviewops-shell) .assigned-review-detail .survey-panel, :host-context(.reviewops-shell) .assigned-review-detail .survey-card {
  position: static;
  max-height: none;
  height: auto;
  overflow: visible;
}
:host-context(.reviewops-shell) .assigned-review-detail .survey-card__header, :host-context(.reviewops-shell) .assigned-review-detail .survey-card__body, :host-context(.reviewops-shell) .assigned-review-detail .survey-actions {
  padding: 16px;
}
:host-context(.reviewops-shell) .assigned-review-detail .survey-card__body {
  max-height: none;
  overflow: visible;
}
:host-context(.reviewops-shell) .assigned-review-detail .survey-section {
  padding: 16px 0;
}
:host-context(.reviewops-shell) .assigned-review-detail .survey-question__title {
  align-items: start;
  gap: 12px;
}
:host-context(.reviewops-shell) .assigned-review-detail .survey-actions {
  position: static;
  border-top: 1px solid var(--ro-line);
}
:host-context(.reviewops-shell) .assigned-review-detail #sample-evidence, :host-context(.reviewops-shell) .assigned-review-detail #sample-evaluation {
  scroll-margin-top: 16px;
}
@media (max-width: 1399px) {
  :host-context(.reviewops-shell) .assigned-review-detail .review-detail-main {
    grid-template-columns: minmax(0, 1fr);
  }
}`],
})
export class PageReviewTaskItemComponent implements OnInit {
    public kind: 'qa' | 'kg' = 'qa';
    public taskId: string = '';
    public task: any = {};
    public samples: any[] = [];
    public selectedSample: number = 0;
    public evidenceOpen: boolean = false;
    public viewedSampleIds: string[] = [];
    public scoreOptions: number[] = [1, 2, 3, 4, 5];
    public surveyDimensions: any[] = [
        { key: 'question_quality', label: '질문 적절성', question: '질문의 대상과 요구사항이 명확하고 원문으로 답할 수 있습니까?' },
        { key: 'answer_accuracy', label: '답변 정확성', question: '답변의 내용과 핵심 사실이 원문과 정확히 일치합니까?' },
        { key: 'evidence_quality', label: '근거 적절성', question: '제시된 근거가 답변의 핵심 내용을 직접적이고 충분하게 뒷받침합니까?' },
        { key: 'qa_composition', label: 'QA 구성 일치성', question: '질문·답변·근거·분류 라벨이 서로 자연스럽고 일관되게 연결됩니까?' },
        { key: 'format_quality', label: '표현·형식 완결성', question: '중복이나 모호한 표현 없이 문장과 형식이 완결되어 있습니까?' },
        { key: 'overall_quality', label: '종합 활용성', question: '전체적으로 수정 없이 사용할 수 있는 QA 품질입니까?' }
    ];
    public decisionOptions: any[] = [
        { value: 'approve', label: '사용 가능', description: '현재 결과를 유지합니다.' },
        { value: 'revise', label: '수정 필요', description: '보완 후 다시 확인합니다.' },
        { value: 'exclude', label: '사용 제외', description: '결과에서 제외합니다.' }
    ];
    public issueOptions: any[] = [
        { code: 'FACT_ERROR', label: '사실 오류' },
        { code: 'EVIDENCE_GAP', label: '근거 부족' },
        { code: 'CONTEXT_GAP', label: '맥락 누락' },
        { code: 'LABEL_MISMATCH', label: '유형·관계 오류' },
        { code: 'DUPLICATE', label: '중복' },
        { code: 'EXPRESSION', label: '표현 개선' }
    ];
    public evaluation: any = this.emptyEvaluation();
    public submitError: string = '';
    public loadError: string = '';
    public loading: boolean = true;
    public submitting: boolean = false;
    public draftSaveError: string = '';
    private workspaceStateLoaded: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.kind = WizRoute.segment.kind === 'kg' ? 'kg' : 'qa';
        this.taskId = WizRoute.segment.id || '';
        this.workspaceStateLoaded = await this.loadWorkspaceTask();
        if (!this.workspaceStateLoaded) {
            await this.service.render();
            return;
        }
        if (!this.task || !this.task.id) {
            await this.service.modal.warning('요청한 검수 작업을 찾을 수 없습니다.', false, '확인');
            this.service.href(this.backRoute());
            return;
        }
        if (!this.canAccessTask()) {
            await this.service.modal.warning('배정되지 않은 검수 작업입니다.', false, '확인');
            this.service.href(this.backRoute());
            return;
        }
        await this.markSampleViewed(this.currentSample().id);
        await this.service.render();
    }

    private async loadWorkspaceTask() {
        this.loading = true;
        try {
            const response = await fetch('/api/v1/review-workspace/state', {
                method: 'GET',
                headers: { Accept: 'application/json' },
                credentials: 'same-origin'
            });
            const payload = await this.readResponse(response);
            if (!response.ok) throw new Error(this.responseMessage(payload, '검수 작업을 불러오지 못했습니다.'));
            const state = this.unwrapData(payload);
            if (!state || !Array.isArray(state.tasks)) throw new Error('검수 작업 응답 형식이 올바르지 않습니다.');
            const source = state.tasks.find((item: any) => {
                return String(item && item.id || '') === this.taskId
                    && String(item && item.kind || '').toLowerCase() === this.kind;
            });
            if (!source) {
                this.task = {};
                this.samples = [];
                this.evaluation = this.emptyEvaluation();
                return true;
            }
            this.task = this.normalizeTask(source, Array.isArray(state.projects) ? state.projects : []);
            this.samples = this.task.samples;
            const dimensions = this.surveySnapshotDimensions(source);
            if (dimensions.length) this.surveyDimensions = dimensions;
            const decisions = this.surveySnapshotDecisionOptions(source);
            if (decisions.length) this.decisionOptions = decisions;
            const issues = this.surveySnapshotIssueOptions(source);
            if (issues.length) this.issueOptions = issues;
            const evaluations = state.evaluations && typeof state.evaluations === 'object' ? state.evaluations : {};
            const drafts = state.evaluation_drafts && typeof state.evaluation_drafts === 'object' ? state.evaluation_drafts : {};
            const serverEvaluation = evaluations[this.task.id];
            const serverDraft = drafts[this.task.id];
            this.evaluation = this.normalizeEvaluation(serverEvaluation || this.emptyEvaluation());
            const draftViewed = serverDraft && Array.isArray(serverDraft.viewed_samples) ? serverDraft.viewed_samples : [];
            this.viewedSampleIds = (serverEvaluation ? this.evaluation.viewed_samples : draftViewed).slice();
            this.evaluation.viewed_samples = this.viewedSampleIds.slice();
            if (this.evaluation.submitted) this.task.status = '제출 완료';
            this.loadError = '';
            return true;
        } catch (error) {
            this.task = {};
            this.samples = [];
            this.evaluation = this.emptyEvaluation();
            this.viewedSampleIds = [];
            this.loadError = error instanceof Error ? error.message : '검수 작업을 불러오지 못했습니다.';
            return false;
        } finally {
            this.loading = false;
        }
    }

    public async reloadWorkspaceTask() {
        this.workspaceStateLoaded = await this.loadWorkspaceTask();
        if (this.workspaceStateLoaded && this.task && this.task.id) {
            await this.markSampleViewed(this.currentSample().id);
        }
        await this.service.render();
    }

    private normalizeTask(task: any, projects: any[]) {
        const projectId = String(task.projectId || task.project_id || '');
        const projectRecord = projects.find((item: any) => String(item && (item.id || item.projectId || item.project_id) || '') === projectId) || {};
        const projectName = typeof task.project === 'string' && task.project.trim()
            ? task.project
            : String(task.projectName || task.project_name || projectRecord.name || projectRecord.title || projectId || '검수 프로젝트');
        const samples = (Array.isArray(task.samples) ? task.samples : []).map((sample: any, index: number) => this.normalizeSample(sample, index));
        return Object.assign({}, task, {
            id: String(task.id || ''),
            projectId: projectId,
            project: projectName,
            title: String(task.title || task.dataset || (this.kind === 'kg' ? 'KG 대표 표본 검수' : 'QA 대표 표본 검수')),
            round: Number(task.round) || this.roundFromId(task.id),
            status: this.statusLabel(task.status),
            survey: String(task.survey || task.surveyName || task.survey_name || '검수 설문지'),
            surveyVersion: String(task.surveyVersion || task.survey_version || 'v1.0'),
            harness: String(task.harness || task.harnessName || task.harness_name || '검수 하네스'),
            harnessVersion: String(task.harnessVersion || task.harness_version || ''),
            target: Number(task.target) || 90,
            assignee: String(task.assignee || task.reviewer || task.assigneeName || task.assignee_name || '검수 담당자'),
            assigneeId: String(task.assigneeId || task.assignee_id || ''),
            assigneeEmail: String(task.assigneeEmail || task.assignee_email || ''),
            due: this.dateLabel(task.due || task.dueAt || task.due_at),
            samples: samples,
            total: Number(task.total ?? task.sampleCount ?? task.sample_count ?? samples.length) || samples.length,
            completed: Number(task.completed ?? task.completedCount ?? task.completed_count) || 0
        });
    }

    private normalizeSample(sample: any, index: number) {
        const source = sample && sample.source;
        const evidence = sample && sample.evidence;
        const answerText = String(sample && sample.answer || '');
        const evidenceText = this.evidenceText(evidence, sample);
        const answerSegments = this.highlightSegments(
            answerText,
            sample && (sample.answerFocus || sample.answer_focus),
            sample && (sample.answerRest || sample.answer_rest)
        );
        const evidenceSegments = this.highlightSegments(
            evidenceText,
            sample && (sample.evidenceFocus || sample.evidence_focus),
            sample && (sample.evidenceRest || sample.evidence_rest)
        );
        return Object.assign({}, sample, {
            id: String(sample && (sample.id || sample.sample_id) || (this.kind.toUpperCase() + '-' + String(index + 1).padStart(4, '0'))),
            type: String(sample && sample.type || this.kind.toUpperCase()).toUpperCase(),
            status: String(sample && sample.status || '대기'),
            risk: String(sample && (sample.risk || sample.risk_label) || '대표 표본'),
            title: String(sample && (sample.title || sample.question || sample.claim || sample.id) || '검수 표본'),
            reason: String(sample && (sample.reason || sample.selection_reason) || '설문지와 하네스 기준으로 선정된 대표 표본입니다.'),
            source: this.sourceLabel(source, sample),
            question: String(sample && sample.question || ''),
            answer: answerText,
            answerBefore: answerSegments.before,
            answerFocus: answerSegments.focus,
            answerAfter: answerSegments.after,
            evidence: evidenceText,
            evidenceBefore: evidenceSegments.before,
            evidenceFocus: evidenceSegments.focus,
            evidenceAfter: evidenceSegments.after,
            nodes: (Array.isArray(sample && sample.nodes) ? sample.nodes : []).map((node: any) => this.nodeLabel(node)),
            relations: (Array.isArray(sample && sample.relations) ? sample.relations : []).map((relation: any) => this.relationLabel(relation)),
            meta: String(sample && (sample.meta || sample.metadata_label) || '')
        });
    }

    private highlightSegments(text: any, focus: any, rest: any) {
        const full = String(text || '');
        const highlighted = String(focus || '');
        const remainder = String(rest || '');
        if (highlighted && full) {
            const offset = full.indexOf(highlighted);
            if (offset >= 0) {
                return {
                    before: full.slice(0, offset),
                    focus: highlighted,
                    after: full.slice(offset + highlighted.length)
                };
            }
        }
        if (highlighted) return { before: '', focus: highlighted, after: remainder };
        return { before: '', focus: '', after: remainder || full };
    }

    private sourceLabel(source: any, sample: any) {
        if (typeof source === 'string') return source;
        if (source && typeof source === 'object') {
            return [source.title || source.document_title || source.document_id, source.version, source.page || source.page_number]
                .filter((value: any) => value !== undefined && value !== null && String(value).trim())
                .join(' · ');
        }
        return String(sample && (sample.source_label || sample.document_title || sample.document_id) || '자료함 원문');
    }

    private evidenceText(evidence: any, sample: any) {
        if (typeof evidence === 'string') return evidence;
        if (evidence && typeof evidence === 'object') return String(evidence.quote || evidence.text || evidence.content || '');
        return String(sample && (sample.quote || sample.evidence_text) || '');
    }

    private nodeLabel(node: any) {
        if (typeof node === 'string') return node;
        if (!node || typeof node !== 'object') return String(node || '');
        const type = String(node.type || node.kind || '').trim();
        const label = String(node.label || node.name || node.id || '').trim();
        return type && label ? type + ' · ' + label : (label || type);
    }

    private relationLabel(relation: any) {
        if (typeof relation === 'string') return relation;
        if (!relation || typeof relation !== 'object') return String(relation || '');
        const source = relation.source || relation.from || relation.subject || '';
        const target = relation.target || relation.to || relation.object || '';
        const type = relation.type || relation.predicate || relation.relation || '';
        return [source, target].filter((value: any) => !!value).join(' → ') + (type ? ' · ' + type : '');
    }

    private surveySnapshotDimensions(task: any) {
        const snapshot = task && (task.survey_snapshot || task.surveySnapshot) || {};
        const dimensions = Array.isArray(snapshot.dimensions) ? snapshot.dimensions : [];
        return dimensions.map((dimension: any, index: number) => ({
            key: String(dimension.key || dimension.id || 'dimension_' + (index + 1)),
            label: String(dimension.label || dimension.name || '평가 항목 ' + (index + 1)),
            question: String(dimension.question || dimension.description || '이 항목의 품질을 평가해주세요.'),
            responseOptions: (Array.isArray(dimension.responseOptions) ? dimension.responseOptions : dimension.response_options || [])
                .map((option: any) => ({
                    value: String(option.value || option.code || ''),
                    label: String(option.label || option.name || option.value || ''),
                    score: option.score === null ? null : Number(option.score)
                }))
                .filter((option: any) => !!option.value && !!option.label)
        }));
    }

    private surveySnapshotDecisionOptions(task: any) {
        const snapshot = task && (task.survey_snapshot || task.surveySnapshot) || {};
        const options = Array.isArray(snapshot.decisionOptions)
            ? snapshot.decisionOptions
            : (Array.isArray(snapshot.decision_options) ? snapshot.decision_options : []);
        return options.map((option: any) => ({
            value: String(option.value || option.code || ''),
            label: String(option.label || option.name || option.value || ''),
            description: String(option.description || '')
        })).filter((option: any) => !!option.value && !!option.label);
    }

    private surveySnapshotIssueOptions(task: any) {
        const snapshot = task && (task.survey_snapshot || task.surveySnapshot) || {};
        const options = Array.isArray(snapshot.issueOptions)
            ? snapshot.issueOptions
            : (Array.isArray(snapshot.issue_options) ? snapshot.issue_options : []);
        return options.map((option: any) => ({
            code: String(option.code || option.value || ''),
            label: String(option.label || option.name || option.code || '')
        })).filter((option: any) => !!option.code && !!option.label);
    }

    private normalizeEvaluation(value: any) {
        const source = value && typeof value === 'object' ? value : {};
        const viewed = source.viewed_samples || source.viewedSampleIds || [];
        const submittedAt = source.submittedAt || source.submitted_at || source.recorded_at || null;
        return {
            scores: source.scores && typeof source.scores === 'object' ? source.scores : {},
            responses: source.responses && typeof source.responses === 'object' ? source.responses : {},
            decision: source.decision || null,
            issues: Array.isArray(source.issues) ? source.issues.slice() : [],
            problemLocation: String(source.problemLocation || source.problem_location || ''),
            comment: String(source.comment || ''),
            request: String(source.request || ''),
            submitted: source.submitted === true || !!submittedAt || !!source.task_id,
            submittedAt: submittedAt,
            startedAt: source.startedAt || source.started_at || new Date().toISOString(),
            durationMinutes: Number(source.durationMinutes ?? source.duration_minutes) || null,
            score: Number(source.score) || 0,
            target: Number(source.target) || Number(this.task && this.task.target) || 90,
            viewed_samples: Array.isArray(viewed) ? viewed.slice() : []
        };
    }

    private roundFromId(id: any) {
        const match = String(id || '').match(/-R(\d+)$/i);
        return match ? Number(match[1]) : 1;
    }

    private statusLabel(status: any) {
        const value = String(status || '').trim();
        const key = value.toLowerCase().replace(/[\s_-]+/g, '');
        if (value === '제출 완료' || value === '검수 완료' || ['submitted', 'completed', 'complete', 'done', 'approved'].includes(key)) return '제출 완료';
        if (value === '검수 중' || ['inprogress', 'progress', 'reviewing', 'started'].includes(key)) return '검수 중';
        return value || '대기';
    }

    private dateLabel(value: any) {
        if (!value) return '—';
        const text = String(value);
        const match = text.match(/^(\d{4})[-.](\d{2})[-.](\d{2})/);
        return match ? [match[1], match[2], match[3]].join('.') : text;
    }

    private async readResponse(response: Response) {
        try {
            return await response.json();
        } catch (error) {
            return {};
        }
    }

    private unwrapData(payload: any) {
        const candidates = [
            payload?.data?.data?.state,
            payload?.data?.state,
            payload?.data?.data,
            payload?.result?.state,
            payload?.state,
            payload?.result,
            payload?.data,
            payload
        ];
        const state = candidates.find((candidate: any) => candidate && typeof candidate === 'object'
            && (
                Object.prototype.hasOwnProperty.call(candidate, 'schema_version')
                || Object.prototype.hasOwnProperty.call(candidate, 'projects')
                || Object.prototype.hasOwnProperty.call(candidate, 'surveys')
                || Object.prototype.hasOwnProperty.call(candidate, 'harnesses')
                || Object.prototype.hasOwnProperty.call(candidate, 'tasks')
                || Object.prototype.hasOwnProperty.call(candidate, 'evaluations')
            ));
        if (!state) return null;
        const rows = (value: any) => Array.isArray(value)
            ? value
            : (value && typeof value === 'object' ? Object.values(value) : []);
        return Object.assign({}, state, {
            projects: rows(state.projects),
            surveys: rows(state.surveys),
            harnesses: rows(state.harnesses),
            tasks: rows(state.tasks),
            evaluations: state.evaluations && typeof state.evaluations === 'object' && !Array.isArray(state.evaluations)
                ? state.evaluations
                : {}
        });
    }

    private responseMessage(payload: any, fallback: string) {
        const data = payload && payload.data;
        const error = payload && payload.error;
        return String(payload && payload.message
            || data && data.message
            || error && (error.message || error)
            || fallback);
    }

    public isAdmin() {
        return this.service.auth.check.role('admin');
    }

    public canAccessTask() {
        if (this.isAdmin()) return true;
        const session = this.service.auth.session || {};
        const email = String(session.email || '').trim().toLowerCase();
        const id = String(session.id || '').trim();
        const hasAssignment = !!String(this.task.assigneeEmail || '').trim() || !!String(this.task.assigneeId || '').trim();
        return !hasAssignment
            || (!!email && email === String(this.task.assigneeEmail || '').toLowerCase())
            || (!!id && id === String(this.task.assigneeId || ''));
    }

    public backRoute() {
        return this.kind === 'kg' ? '/kg-reviews' : '/human-reviews';
    }

    public kindLabel() {
        return this.kind === 'kg' ? 'KG 검수' : 'QA 검수';
    }

    public isReadOnly() {
        return this.evaluation.submitted === true;
    }

    public resultRoute() {
        return '/review-results/' + this.kind + '/' + this.task.id;
    }

    public fullDatasetRoute() {
        return '/review-tasks/qa/' + this.task.id + '/dataset';
    }

    public fullQaCount() {
        return Number(this.task.fullQaCount ?? this.task.qaCount ?? this.samples.length) || this.samples.length;
    }

    public currentSample() {
        return this.samples[this.selectedSample] || this.samples[0] || {};
    }

    public completedCount() {
        return this.viewedSampleIds.filter((id: string) => this.samples.some((sample: any) => sample.id === id)).length;
    }

    public taskProgress() {
        if (!this.samples.length) return 0;
        return Math.round(this.completedCount() / this.samples.length * 100);
    }

    public hasViewedSample(sampleId: string) {
        return this.viewedSampleIds.indexOf(sampleId) > -1;
    }

    public allSamplesViewed() {
        return this.samples.length > 0 && this.completedCount() === this.samples.length;
    }

    public sampleStatus(sample: any) {
        return this.hasViewedSample(sample && sample.id) ? '확인 완료' : '확인 전';
    }

    public surveyProgress() {
        if (this.usesCategoricalSurvey()) {
            return this.surveyDimensions.filter((item: any) => !!this.evaluation.responses[item.key]).length;
        }
        return this.surveyDimensions.filter((item: any) => !!this.evaluation.scores[item.key]).length;
    }

    public usesCategoricalSurvey() {
        return this.surveyDimensions.length > 0
            && this.surveyDimensions.every((item: any) => Array.isArray(item.responseOptions) && item.responseOptions.length > 0);
    }

    public surveySourceLabel() {
        const snapshot = this.task && (this.task.survey_snapshot || this.task.surveySnapshot) || {};
        const page = Number(snapshot.sourcePage || snapshot.source_page);
        return page > 0 ? `연결 설문지 ${page}페이지에서 추출` : '연결 설문지 스냅샷';
    }

    public surveyScoreLabel() {
        return this.usesCategoricalSurvey() ? this.categoricalScoreRatio() : this.draftAverage();
    }

    public surveyScoreCaption() {
        return this.usesCategoricalSurvey() ? '가중 환산 점수' : '현재 점수';
    }

    public categoricalScoreRatio() {
        const dimensionCount = this.surveyDimensions.length;
        if (!dimensionCount) return '—';
        const pointPerDimension = 100 / dimensionCount;
        let earned = 0;
        let available = 100;

        this.surveyDimensions.forEach((dimension: any) => {
            const response = this.evaluation.responses[dimension.key];
            if (!response) return;
            const option = (dimension.responseOptions || []).find((item: any) => item.value === response);
            if (!option) return;
            if (option.score === null) {
                available -= pointPerDimension;
                return;
            }
            const score = Number(option.score);
            if (!Number.isFinite(score)) return;
            earned += Math.max(0, Math.min(5, score)) / 5 * pointPerDimension;
        });

        return `${this.formatScorePoint(earned)} / ${this.formatScorePoint(Math.max(0, available))}`;
    }

    private formatScorePoint(value: number) {
        const rounded = Math.round(value * 10) / 10;
        return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
    }

    public draftAverage() {
        const values = this.surveyDimensions
            .map((item: any) => this.evaluation.scores[item.key])
            .filter((value: any) => !!value);
        if (!values.length) return '—';
        const average = values.reduce((sum: number, value: number) => sum + value, 0) / values.length;
        return (average * 20).toFixed(1);
    }

    public async selectSample(index: number) {
        if (index < 0 || index >= this.samples.length) return;
        this.selectedSample = index;
        this.evidenceOpen = false;
        await this.markSampleViewed(this.currentSample().id);
        await this.service.render();
    }

    public async previousSample() {
        if (!this.samples.length) return;
        await this.selectSample((this.selectedSample - 1 + this.samples.length) % this.samples.length);
    }

    public async nextSample() {
        if (!this.samples.length) return;
        await this.selectSample((this.selectedSample + 1) % this.samples.length);
    }

    public async toggleEvidence() {
        this.evidenceOpen = !this.evidenceOpen;
        await this.service.render();
    }

    public async setScore(key: string, score: number) {
        if (this.isReadOnly()) return;
        this.evaluation.scores[key] = score;
        this.submitError = '';
        await this.service.render();
    }

    public async setSurveyResponse(key: string, value: string) {
        if (this.isReadOnly()) return;
        if (this.evaluation.responses[key] === value) {
            delete this.evaluation.responses[key];
        } else {
            this.evaluation.responses[key] = value;
        }
        this.submitError = '';
        await this.service.render();
    }

    public async setDecision(value: string) {
        if (this.isReadOnly()) return;
        this.evaluation.decision = value;
        this.submitError = '';
        await this.service.render();
    }

    public async toggleIssue(code: string) {
        if (this.isReadOnly()) return;
        const index = this.evaluation.issues.indexOf(code);
        if (index > -1) this.evaluation.issues.splice(index, 1);
        else this.evaluation.issues.push(code);
        this.submitError = '';
        await this.service.render();
    }

    public hasIssue(code: string) {
        return this.evaluation.issues.indexOf(code) > -1;
    }

    public async updateComment(event: any) {
        if (this.isReadOnly()) return;
        this.evaluation.comment = event.target.value;
    }

    public async updateProblemLocation(event: any) {
        if (this.isReadOnly()) return;
        this.evaluation.problemLocation = event.target.value;
    }

    public async updateRequest(event: any) {
        if (this.isReadOnly()) return;
        this.evaluation.request = event.target.value;
    }

    public async submitEvaluation() {
        if (this.submitting || this.isReadOnly()) return;
        this.submitError = '';
        if (this.surveyProgress() < this.surveyDimensions.length || !this.evaluation.decision) {
            await this.service.modal.warning(this.surveyDimensions.length + '개 평가 문항과 최종 판정을 모두 선택해주세요.', false, '확인');
            return;
        }
        if (
            this.evaluation.decision !== 'approve'
            && !String(this.evaluation.comment || '').trim()
            && !String(this.evaluation.request || '').trim()
        ) {
            await this.service.modal.warning('수정 또는 확인이 필요한 이유를 검수 의견이나 수정·확인 사항에 줄글로 입력해주세요.', false, '확인');
            return;
        }
        const submittedAt = new Date();
        const startedAt = new Date(this.evaluation.startedAt || submittedAt.toISOString());
        const durationMinutes = Math.max(0.1, Math.round((submittedAt.getTime() - startedAt.getTime()) / 6000) / 10);
        const submission = {
            task_id: this.task.id,
            scores: this.evaluation.scores,
            responses: this.usesCategoricalSurvey() ? this.evaluation.responses : undefined,
            viewed_samples: this.viewedSampleIds.slice(),
            decision: this.evaluation.decision,
            issues: this.evaluation.issues.slice(),
            problem_location: this.evaluation.problemLocation,
            comment: this.evaluation.comment,
            request: this.evaluation.request,
            started_at: this.evaluation.startedAt || submittedAt.toISOString(),
            submitted_at: submittedAt.toISOString(),
            duration_minutes: durationMinutes
        };
        this.submitting = true;
        await this.service.render();
        try {
            const body = new URLSearchParams();
            body.set('payload', JSON.stringify(submission));
            const response = await fetch('/api/v1/review-workspace/evaluation', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                credentials: 'same-origin',
                body: body.toString()
            });
            const payload = await this.readResponse(response);
            if (!response.ok) throw new Error(this.responseMessage(payload, '검수 결과를 제출하지 못했습니다.'));
            const result = this.unwrapData(payload) || {};
            const returned = result.evaluation
                || result.evaluations && result.evaluations[this.task.id]
                || result;
            this.evaluation = this.normalizeEvaluation(Object.assign({}, submission, returned, {
                submitted: true,
                submitted_at: returned.submitted_at || returned.submittedAt || submission.submitted_at,
                duration_minutes: returned.duration_minutes ?? returned.durationMinutes ?? durationMinutes,
                viewed_samples: returned.viewed_samples || submission.viewed_samples
            }));
            this.viewedSampleIds = this.evaluation.viewed_samples.slice();
            this.task.status = '제출 완료';
            this.task.completed = this.samples.length;
            this.workspaceStateLoaded = true;
        } catch (error) {
            this.submitError = error instanceof Error ? error.message : '검수 결과를 제출하지 못했습니다.';
            this.submitting = false;
            await this.service.render();
            await this.service.modal.warning(this.submitError, false, '확인');
            return;
        }
        this.submitting = false;
        await this.service.render();
        await this.service.modal.success('대표 샘플 종합 검수 결과를 제출했습니다.');
        this.service.href('/review-results/' + this.kind + '/' + this.task.id);
    }

    private emptyEvaluation() {
        return {
            scores: {},
            responses: {},
            decision: null,
            issues: [],
            problemLocation: '',
            comment: '',
            request: '',
            submitted: false,
            submittedAt: null,
            startedAt: new Date().toISOString(),
            durationMinutes: null,
            score: 0,
            target: 90,
            viewed_samples: []
        };
    }

    private async markSampleViewed(sampleId: string) {
        if (!sampleId || this.hasViewedSample(sampleId) || this.isReadOnly()) return;
        this.viewedSampleIds.push(sampleId);
        this.evaluation.viewed_samples = this.viewedSampleIds.slice();
        await this.persistViewedSamples();
    }

    private async persistViewedSamples() {
        if (!this.task || !this.task.id || this.isReadOnly()) return;
        const body = new URLSearchParams();
        body.set('payload', JSON.stringify({
            task_id: this.task.id,
            viewed_samples: this.viewedSampleIds.slice()
        }));
        try {
            const response = await fetch('/api/v1/review-workspace/evaluation-draft', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', Accept: 'application/json' },
                credentials: 'same-origin',
                body: body.toString()
            });
            const payload = await this.readResponse(response);
            if (!response.ok) throw new Error(this.responseMessage(payload, '대표 샘플 확인 상태를 저장하지 못했습니다.'));
            const result = this.unwrapData(payload);
            const draft = result && result.draft || {};
            if (Array.isArray(draft.viewed_samples)) {
                this.viewedSampleIds = draft.viewed_samples.slice();
                this.evaluation.viewed_samples = this.viewedSampleIds.slice();
            }
            this.draftSaveError = '';
        } catch (error) {
            this.draftSaveError = error instanceof Error ? error.message : '대표 샘플 확인 상태를 저장하지 못했습니다.';
        }
    }
}

export default PageReviewTaskItemComponent;